module.exports = "/_next/static/images/ico-share-de0426f7af5089193f68c008cf476a50.svg";